module.exports = __webpack_public_path__ + "images/interview-Walt_Disney_Company-2.svg";